import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { deleteTokenForContact, getToken, isManageable, listManageableTokens, markTokenAsManageable, queryTokens, unMarkTokenAsManageable, updateManageableTokenGuidelines, upsertToken } from '@wix/ambassador-asa-token-v1-token/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { CalendarTokenClientBase } from './CalendarTokenClientBase';
export class CalendarTokenClient extends HttpBaseClient(CalendarTokenClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "deleteTokenForContactImpl", deleteTokenForContact);
    _defineProperty(this, "listManageableTokensImpl", listManageableTokens);
    _defineProperty(this, "getTokenImpl", getToken);
    _defineProperty(this, "queryTokensImpl", queryTokens);
    _defineProperty(this, "upsertTokenImpl", upsertToken);
    _defineProperty(this, "markTokenAsManageableImpl", markTokenAsManageable);
    _defineProperty(this, "unMarkTokenAsManageableImpl", unMarkTokenAsManageable);
    _defineProperty(this, "updateManageableTokenGuidelinesImpl", updateManageableTokenGuidelines);
    _defineProperty(this, "isManageableTokenImpl", isManageable);
  }
}
//# sourceMappingURL=CalendarTokenClientHttp.js.map